import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { PrivacyPolicyResponse } from '../models/privacy-policy-response.model';
import { PrivacyPolicyRepository } from '../repositories/privacy-policy.respository';

export class GetPrivacyPolicyUseCase
    implements UseCase<never, PrivacyPolicyResponse>
{
    constructor(private readonly repository: PrivacyPolicyRepository) {}

    execute(): Observable<PrivacyPolicyResponse> {
        return this.repository.getPrivacyPolicy();
    }
}
